import React from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const STATUS = ["new", "in_progress", "done", "spam"];

export default function SubmissionsAdmin() {
  const [items, setItems] = React.useState([]);
  const [open, setOpen] = React.useState(null);
  const load = () => api.submissions().then(setItems);
  React.useEffect(() => { load(); }, []);
  const updateStatus = async (id, status) => {
    await api.updateSubmission(id, { status });
    setItems(items.map(s => s.id === id ? { ...s, status } : s));
    toast.success("Status aktualisiert");
  };

  return (
    <div data-testid="admin-submissions">
      <div className="mb-6"><div className="brut-tag mb-3">CMS / ANFRAGEN</div><h1 className="brut-h2">Praxis-Check Anfragen</h1></div>
      <table className="admin-table w-full">
        <thead>
          <tr className="border-b-2 border-[var(--ink)]">
            <th className="py-3 text-left">Datum</th>
            <th className="py-3 text-left">Praxis</th>
            <th className="py-3 text-left">Name</th>
            <th className="py-3 text-left">E-Mail</th>
            <th className="py-3 text-left">Scanner</th>
            <th className="py-3 text-left">Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {items.map(s => (
            <React.Fragment key={s.id}>
              <tr className="border-b border-[var(--line-soft)]" data-testid={`sub-row-${s.id}`}>
                <td className="py-3 font-mono text-xs">{(s.created_at || "").slice(0, 16).replace("T", " ")}</td>
                <td className="py-3">{s.praxisname}</td>
                <td className="py-3">{s.name}</td>
                <td className="py-3 font-mono text-xs">{s.email}</td>
                <td className="py-3 font-mono text-xs uppercase">{s.scanner_status}</td>
                <td className="py-3">
                  <select className="brut-select !py-1 !px-2 text-xs" value={s.status} onChange={e => updateStatus(s.id, e.target.value)}>
                    {STATUS.map(x => <option key={x} value={x}>{x}</option>)}
                  </select>
                </td>
                <td className="py-3 text-right"><button onClick={() => setOpen(open === s.id ? null : s.id)} className="font-mono text-xs underline">{open === s.id ? "schließen" : "Details"}</button></td>
              </tr>
              {open === s.id && (
                <tr><td colSpan={7} className="bg-[#FAFAFA] p-5">
                  <div className="grid grid-cols-2 gap-3 text-sm">
                    <div><span className="font-mono text-[10px] uppercase opacity-60">Produkt:</span> {s.product || "—"}</div>
                    <div><span className="font-mono text-[10px] uppercase opacity-60">Anliegen:</span> {s.concern || "—"}</div>
                    <div><span className="font-mono text-[10px] uppercase opacity-60">Tel:</span> {s.phone || "—"}</div>
                    <div><span className="font-mono text-[10px] uppercase opacity-60">Scanner-Modell:</span> {s.scanner_model || "—"}</div>
                    <div><span className="font-mono text-[10px] uppercase opacity-60">Fallzahl/Monat:</span> {s.case_volume || "—"}</div>
                    <div className="col-span-2"><span className="font-mono text-[10px] uppercase opacity-60">Leistungen:</span> {(s.services || []).join(", ")}</div>
                    {s.message && <div className="col-span-2"><span className="font-mono text-[10px] uppercase opacity-60">Nachricht:</span><br/>{s.message}</div>}
                  </div>
                </td></tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
